import { useEffect, useState } from "react";

export const useCountdown = (seconds: number) => {
    const [time, setTime] = useState(seconds);

    useEffect(() => {
        if (time === 0) return;
        const id = setInterval(() => setTime((t) => t - 1), 1000);
        return () => clearInterval(id);
    }, [time]);

    return { time, reset: () => setTime(seconds) };
};
